import { registerStore } from '../../common/utilsClient/multiReducer';

const store = registerStore({
  path: 'ui.screens.ProjectsDashboard',
  initialState: {
    cards: {},
    dashboards: {},
    dialogs: {},
    // review:accepted: this top-level `filters` is not the value the dashboard filter seeding looks at. DashboardTimeline (ConnectedFilters, ProjectMilestones) reads and seeds `dashboards.<dashboardId>.filters`, which still starts undefined, so the default filters are seeded as before.
    filters: [],
    activePatientId: null,
    activeMilestoneId: null,
    activeActivityId: null,
    activeAnswersSheetId: null,
    activeNoteId: null,
    editNoteDialogVisible: false,
    editMilestoneDialogVisible: false,
    milestoneDialogVisible: false,
    milestoneDialogActiveKey: 'questionnaires',
    answersSheetDialogVisible: false,
    remindersDialogVisible: false,
    addAnswersSheetsDialogVisible: false,
    removeAnswersSheetDialogVisible: false,
    previewPatientResponseDialogVisible: false,
    tabs: [],
  },
});

export default store;
